export const ADMINISTRADOR = 'administrador';
export const GERENTE = 'gerente';
export const REPRESENTANTE = 'representante';
export const EMPLEADO = 'empleado';
export const ADMINISTRADOR_ZONA = 'administrador_zona';
export const SYSTEM = 'system';
